import { render } from "./JobCarousel.vue?vue&type=template&id=84705fa8&scoped=true"
import script from "./JobCarousel.vue?vue&type=script&lang=js"
export * from "./JobCarousel.vue?vue&type=script&lang=js"

import "./JobCarousel.vue?vue&type=style&index=0&id=84705fa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84705fa8"]])

export default __exports__